import React, { useState ,useEffect } from "react";
//import Logo from "../../../images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import PageContainer from "../../../components/pages/PageContainer";
import { event } from "../../../utils/event";

function StartScreen() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  //const [email, setEmail] = useState("");
  //const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    setError(false);
    // console.log(email);
    // console.log(password);
    console.log(error);
    setLoading(true);
    navigate("/");
  };

  useEffect(() => {
    event("sendDataToReactApp");
  },[])

  return (
    <>
      <PageContainer>
        <div className="flex min-h-screen">
          <div className="flex justify-center w-full flex-col md:flex-row">
            {/* Image */}
            <div className="md:bg-primaryColor md:min-h-screen flex flex-wrap md:w-1/2">
              <div className="items-center text-center flex flex-col relative justify-center mx-auto mt-2">
                <img
                  src={"/qushi_logo.png"}
                  alt="Logo Login"
                  className="md:w-48 w-48 mx-auto"
                />
              </div>
            </div>
            {/* Login Section */}
            <div className="flex flex-col  md:flex-1 items-center justify-center mt-5">
              <div className="loginWrapper flex flex-col w-full lg:px-36 md:px-8 px-8 md:py-8 mb-4">
                <div className=" block my-4 text-center">
                  <h1 className="text-2xl font-semibold">BEGINNER TRADERS</h1>
                  <p className="text-gray-500 text-s">
                    learn to trade from top performers with proven track records
                  </p>
                </div>
                <div className=" block my-4 text-center">
                  <h1 className="text-2xl font-semibold">ADVANCED TRADERS</h1>
                  <p className="text-gray-500 text-s">
                    monetize your content and become a trading influencer
                  </p>
                </div>
                <div className=" block my-4 text-center">
                  <h1 className="text-2xl font-semibold">FOLLOW THE TREND</h1>
                  <p className="text-gray-500 text-s">
                    sign up and receive $1M QUSHi coins to start trading today
                  </p>
                </div>

                {/* start screen button */}
                <div className="md:mt-10 mt-7">
                  <form onSubmit={handleSubmit}>
                    {/* Create Account Button */}
                    <div className="flex w-full">
                      <Link className="flex w-full" to="/auth/register">
                        <button
                          disabled={loading}
                          type="submit"
                          className="flex items-center justify-center focus:outline-none text-white text-sm bg-primaryColor rounded-xl md:rounded-xl md:py-3 py-3 w-full"
                        >
                          <span className="mr-2 md:uppercase font-bold">
                            Create Account
                          </span>
                        </button>
                      </Link>
                    </div>
                    {/* Sign-in  Button */}
                    <div className="flex justify-between w-full mt-6 ">
                      <Link
                        to="/auth/login"
                        className="flex justify-between w-full"
                      >
                        <button
                          disabled={loading}
                          type="submit"
                          className="flex items-center justify-center focus:outline-none text-slate-500 text-sm bg-white border-2 border-primaryColor rounded-lg md:rounded md:py-2 px-3 py-3 w-full transition duration-150 ease-in"
                        >
                          <span className="mr-2 flex-1 text-primaryColor font-bold">
                            Sign in
                          </span>
                        </button>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  );
}

export default StartScreen;
